import { FC } from "react";
import { Icon, FlagsIcons } from "@smile2impress/components";
import { UTSLocale } from "@smile2impress/attraction-constants";

interface FlagIconByLocaleProps {
    locale: UTSLocale;
    width?: number | string | number[] | string[];
    height?: number | string | number[] | string[];
}

export const FlagIconByLocale: FC<FlagIconByLocaleProps> = ({
    locale,
    width = "24px",
    height = "24px",
}: FlagIconByLocaleProps) => {
    const getIcon = (FlagIconComponent: any) => (
        <Icon as={FlagIconComponent} w={width} h={height} />
    );

    switch (locale) {
        case UTSLocale.SPAIN_ES:
            return getIcon(FlagsIcons.EsIcon);
        case UTSLocale.FRANCE_FR:
            return getIcon(FlagsIcons.FrIcon);
        case UTSLocale.ITALY_IT:
            return getIcon(FlagsIcons.ItIcon);
        case UTSLocale.PORTUGAL_PT:
            return getIcon(FlagsIcons.PtIcon);
        case UTSLocale.GB_EN:
            return getIcon(FlagsIcons.GbIcon);
        case UTSLocale.UKRAINE_UK:
            return getIcon(FlagsIcons.UaIcon);
        case UTSLocale.US_EN:
            return getIcon(FlagsIcons.UsIcon);
        case UTSLocale.GERMANY_DE:
            return getIcon(FlagsIcons.DeIcon);
        case UTSLocale.SWEDEN_SE:
            return getIcon(FlagsIcons.SeIcon);
        case UTSLocale.NL_NL:
            return getIcon(FlagsIcons.NlIcon);
        case UTSLocale.DENMARK_DK:
            return getIcon(FlagsIcons.DkIcon);
        default:
            return null;
    }
};
